// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import './styles/index.scss'
import BaiduMap from 'vue-baidu-map'
import $api from './api'
import CosAuth from "../public/cos-auth.min.js";
import promise from 'es6-promise'
// import 'lib-flexible/flexible'
import watermark from '../src/utils/watermark.js'
promise.polyfill();
// 图片懒加载
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  preLoad: 1.3, // defaule 1.3
  error: require('./assets/images/img_loading_error.png'),
  loading: require('./assets/images/img_loading.png'),
  attempt: 1
})
Vue.use(ElementUI)
Vue.config.productionTip = false
/* eslint-disable no-new */
Vue.prototype.$api = $api

Vue.prototype.$CosAuth = CosAuth;

Vue.use(BaiduMap, {
  ak: 'i3muyci0mawGASxnZL3oUkKagmHr7QQM'
})
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js